export enum PinSetSource {
  ProgressChecklist = 'PROGRESS_CHECKLIST',
}
